/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
// back: https://smallfish.antfin-inc.com/jsapi/back.html
// 注意：iOS端侧滑返回，由于手势操作具有可中途撤销的特性，无法触发back事件。
function onBackCatcher(cb) {
    var handler = function (e) {
        e.preventDefault(); // 首先屏蔽默认行为，然后调用页面跳转API进行手动控制
        if (typeof cb !== 'function') {
            return;
        }
        cb();
    };
    document.addEventListener('back', handler, false);
    return function () { return document.removeEventListener('back', handler, false); };
}

export { onBackCatcher as default };
